module.exports = __webpack_public_path__ + "img/丝路文博网_02.e62b712d.jpg";